/**
 * 계정정보찾기 API
 * FSD: features/account-recovery/api
 */

import { publicClient } from "@/shared/api/public-client";
import {
  FindIdRequest,
  FindIdResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
} from "../model/account-recovery.types";

/**
 * 아이디 찾기
 */
export async function findId(req: FindIdRequest): Promise<FindIdResponse> {
  try {
    const response = await publicClient.post<FindIdResponse>(
      "/v1/users/find-id",
      req
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "아이디 조회에 실패했습니다."
    );
  }
}

/**
 * 비밀번호 초기화 요청
 */
export async function requestPasswordReset(
  req: ResetPasswordRequest
): Promise<ResetPasswordResponse> {
  try {
    const response = await publicClient.post<ResetPasswordResponse>(
      "/v1/users/reset-password",
      req
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "비밀번호 초기화에 실패했습니다."
    );
  }
}
